// Global Instructions Rule Applied!
//
// Generic agent-written meeting document card (prep notes / investment
// themes) — the DealBriefCard treatment: FormSection + Agent-written Tag +
// updated date. Body: AgentMarkdown for content_format='markdown' (the
// post-2026-09-02 docs), else plain text with preserved line breaks.
import React from 'react'
import { Tag } from 'antd'
import dayjs from 'dayjs'
import { FormSection } from '../../../core/components/FormSection.tsx'
import type { FormSectionProps } from '../../../core/components/FormSection.tsx'
import { AgentMarkdown } from '../../../core/components/AgentMarkdown.tsx'
import { MeetingDoc } from '../../../state_manager/data_models/pipeline_meetings_model.ts'

export const MeetingDocBody: React.FC<{ doc: MeetingDoc }> = ({ doc }) =>
  doc.content_format === 'markdown' ? (
    <AgentMarkdown source={doc.content} />
  ) : (
    <div className='whitespace-pre-line text-[13px]'>{doc.content}</div>
  )

interface MeetingDocCardProps {
  title: string
  titleColor?: FormSectionProps['titleColor']
  doc: MeetingDoc | null
  loading: boolean
  emptyText: string
}

export const MeetingDocCard: React.FC<MeetingDocCardProps> = ({
  title,
  titleColor = 'blue',
  doc,
  loading,
  emptyText
}) => (
  <FormSection
    data-component='MeetingDocCard'
    title={title}
    titleColor={titleColor}
    loading={loading}
    className='shadow-sm border border-gray-200'
    headerActions={
      <span className='flex items-center gap-2'>
        <Tag color='blue'>Agent-written</Tag>
        {doc?.generated_at ? (
          <span className='text-gray-400 text-[11.5px]'>
            updated {dayjs(doc.generated_at).format('MM/DD/YYYY')}
          </span>
        ) : null}
      </span>
    }
  >
    {doc?.content ? (
      <MeetingDocBody doc={doc} />
    ) : !loading ? (
      <div className='text-gray-400 text-xs py-2'>{emptyText}</div>
    ) : null}
  </FormSection>
)
